<template>
  <EstatisticasFilters :loading="isLoading" @filter="onFilters" />
  <div v-show="isLoading" class="row mx-md-n5 text-center">
    <div class="col py-3 px-md-5">
      <div :class="'spinner-border'" />
    </div>
  </div>
  <div v-show="!isLoading">
    <div class="container">
      <div class="row g-2 ">
        <div class="col-sm-3 p-3">
          <CardEstatistica :titulo="chartsData.quantidadeContasPagas" :sub-titulo="$t('quantidadeContasPagas')" />
        </div>
        <div class="col-sm-3 p-3">
          <CardEstatistica
            :titulo="chartsData.quantidadeContasGratuitas" :sub-titulo="$t('quantidadeContasGratuitas')"
          />
        </div>
        <div class="col-sm-3 p-3">
          <CardEstatistica
            :titulo="chartsData.quantidadeLicencaGratuitaSemOS" :sub-titulo="$t('quantidadeLicencaGratuitaSemOS')"
          />
        </div>
        <div class="col-sm-3 p-3">
          <CardEstatistica
            :titulo="chartsData.quantidadeUsuariosContaPagantes" :sub-titulo="$t('quantidadeUsuariosContaPagantes')"
          />
        </div>
      </div>
      <div class="row g-3">
        <div class="col-sm-3 p-3">
          <CardEstatistica :titulo="chartsData.quantidadeEmpresas" :sub-titulo="$t('empresas')" />
        </div>
        <div class="col-sm-3 p-3">
          <CardEstatistica :titulo="chartsData.quantidadePagantesSemOS" :sub-titulo="$t('quantidadePagantesSemOS')" />
        </div>
        <div class="col-sm-3 p-3">
          <CardEstatistica :titulo="chartsData.mediaContasDia" :sub-titulo="$t('mediaContasDia')" />
        </div>
        <div class="col-sm-3 p-3">
          <CardEstatistica :titulo="contaPaganteAntiga.razaoSocial" :sub-titulo="$t('contaPaganteAntiga')" />
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row g-2">
        <div class="col-sm-6 p-3">
          <PagantesChart :loading="isLoading" />
        </div>
        <div class="col-sm-6 p-3">
          <QuantidadeOSChart :loading="isLoading" />
        </div>
      </div>
    </div>
    <QuantidadeContasMesChart :loading="isLoading" />
    <QuantidadePagantesDiaChart :loading="isLoading" />
    <QuantidadeNovosPagantesDiaChart :loading="isLoading" />
    <ContasLocalidadeChart :loading="isLoading" />
  </div>
</template>

<script>
import EstatisticasFilters from './EstatisticasFilters.vue';
import { getEstatisticasCharts } from '../estatisticasService';
import PagantesChart from './PagantesChart.vue';
import QuantidadeOSChart from './QuantidadeOSChart.vue';
import QuantidadeContasMesChart from './QuantidadeContasMesChart.vue';
import ContasLocalidadeChart from './ContasLocalidadeChart.vue';
import { useToast } from 'vue-toastification';
import eventbus from '@/modules/core/services/eventbus';
import CardEstatistica from './CardEstatistica.vue';
import QuantidadePagantesDiaChart from './QuantidadePagantesDiaChart.vue';
import QuantidadeNovosPagantesDiaChart from './QuantidadeNovosPagantesDiaChart.vue';
export default {
  components: {
    EstatisticasFilters,
    PagantesChart,
    QuantidadeOSChart,
    QuantidadeContasMesChart,
    ContasLocalidadeChart,
    CardEstatistica,
    QuantidadePagantesDiaChart,
    QuantidadeNovosPagantesDiaChart,
  },
  emits: ['update-charts'],
  data: () => ({ isLoading: false, chartsData: {}, contaPaganteAntiga: {}, carregamentoInicial: true }),
  methods: {
    async onFilters(filters) {
      try {
        this.isLoading = true;
        this.chartsData = await getEstatisticasCharts(filters);
        eventbus.emit('update-charts', this.chartsData);
        this.contaPaganteAntiga = this.chartsData.contaPaganteAntiga;
      } catch (error) {
        useToast().error(this.$t('erroAoObterDashboard'));
      }
      this.isLoading = false;
      this.carregamentoInicial = false;
    },
  },
};
</script>
